export type ColorModeContrastPreference = "system" | "less" | "more";

export type UserAccessibilityPreferencesPayload = {
  color_mode_contrast?: ColorModeContrastPreference;
};

export const COLOR_MODE_CONTRAST_OPTIONS: readonly ColorModeContrastPreference[] =
  ["system", "less", "more"];
